module.exports = __webpack_public_path__ + "static/media/Avatars_Other-29.8886229c.png";